import axios from "axios";
import { BASE_API_URL } from "../consts";

export interface HierarchyUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar?: any;
  profilePicture?: string;
  phone?: string;
  position?: {
    _id: string;
    positionName: string;
    mainCategory: string;
  };
  managerId?: any;
  hierarchyLevel: number;
  directReports?: any[];
  isManager: boolean;
  children?: HierarchyUser[];
  teamSize?: number;
}

export interface OrganizationChartResponse {
  success: boolean;
  data: HierarchyUser[];
  totalEmployees: number;
}

export interface ManagerTeamResponse {
  success: boolean;
  manager: {
    _id: string;
    firstName: string;
    lastName: string;
    position?: any;
  };
  team: HierarchyUser[];
  teamSize: number;
}

export interface ReportingChainResponse {
  success: boolean;
  chain: HierarchyUser[];
  levels: number;
}

export interface HierarchyStats {
  totalEmployees: number;
  totalManagers: number;
  avgTeamSize: number;
  maxLevel: number;
}

export interface HierarchyStatsResponse {
  success: boolean;
  stats: HierarchyStats;
  levelDistribution: Array<{ _id: number; count: number }>;
}

// Get complete organization chart
export const getOrganizationChart = async (clientId: string) => {
  const response = await axios.get<OrganizationChartResponse>(
    `${BASE_API_URL}/hierarchy/organization-chart`,
    {
      params: { clientId },
    }
  );
  return response.data;
};

// Get manager's team
export const getManagerTeam = async (
  userId: string,
  includeNested: boolean = false
) => {
  const response = await axios.get<ManagerTeamResponse>(
    `${BASE_API_URL}/hierarchy/${userId}/team`,
    {
      params: { includeNested },
    }
  );
  return response.data;
};

// Get reporting chain
export const getReportingChain = async (userId: string) => {
  const response = await axios.get<ReportingChainResponse>(
    `${BASE_API_URL}/hierarchy/${userId}/chain`
  );
  return response.data;
};

// Assign manager to user
export const assignManager = async (
  userId: string,
  managerId: string | null
) => {
  const response = await axios.put(
    `${BASE_API_URL}/hierarchy/${userId}/assign-manager`,
    { managerId }
  );
  return response.data;
};

// Recalculate hierarchy levels
export const recalculateHierarchy = async (clientId: string) => {
  const response = await axios.post(`${BASE_API_URL}/hierarchy/recalculate`, {
    clientId,
  });
  return response.data;
};

// Get hierarchy statistics
export const getHierarchyStats = async (clientId: string) => {
  const response = await axios.get<HierarchyStatsResponse>(
    `${BASE_API_URL}/hierarchy/stats`,
    {
      params: { clientId },
    }
  );
  return response.data;
};
